__turbopack_context__.v({
  "blocks": "highlight-module__ouF_kW__blocks",
  "container": "highlight-module__ouF_kW__container",
  "fadeInItems": "highlight-module__ouF_kW__fadeInItems",
  "label": "highlight-module__ouF_kW__label",
  "labelMobile": "highlight-module__ouF_kW__labelMobile",
  "name": "highlight-module__ouF_kW__name",
  "sidebar": "highlight-module__ouF_kW__sidebar",
  "spacing--lg": "highlight-module__ouF_kW__spacing--lg",
  "spacing--md": "highlight-module__ouF_kW__spacing--md",
  "spacing--sm": "highlight-module__ouF_kW__spacing--sm",
  "spacing--xl": "highlight-module__ouF_kW__spacing--xl",
  "spacing--xs": "highlight-module__ouF_kW__spacing--xs",
  "spacing--xxl": "highlight-module__ouF_kW__spacing--xxl",
  "spacing--xxs": "highlight-module__ouF_kW__spacing--xxs",
  "spacing--xxxl": "highlight-module__ouF_kW__spacing--xxxl",
  "spacing--xxxs": "highlight-module__ouF_kW__spacing--xxxs",
});
